// Startseite je Benutzer: Cockpit, sonst die erste erlaubte Seite (ZeitApp-Nutzer → Zeiterfassung).
import { SEITEN } from "./katalog";

export function startseite(rechte: readonly string[]): string {
  const hat = new Set(rechte);
  if (hat.has("cockpit")) return "/";
  if (hat.size === 1 && hat.has("team.eigene")) return "/zeit";  // nur Zeiterfassung → ZeitApp (mobil)
  const erste = SEITEN.find((s) => !s.versteckt && s.rechte.length > 0 && s.rechte.some((r) => hat.has(r)));
  return erste?.pfad ?? "/verwaltung/einstellungen";
}
